import * as Highcharts from 'highcharts';

import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  Renderer2
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DataStorageService} from 'shared/services/data-storage.service';
import {ChartTemplateService} from '../../../cockpit-shared/charts-templates/chart-template.service';
import {
  CockpitChartComponent,
  CockpitContentComponent
} from '../../../cockpit-shared/cockpit-content-component';
import {CockpitCard} from 'shared/dtos/cockpit-card';

@Component({
  selector: 'app-chart-leave-one-out',
  templateUrl: './chart-leave-one-out.component.html',
  styleUrl: '../../../cockpit-shared/card/card.component.scss',
  providers: [ChartTemplateService],
  standalone: false
})
export class ChartLeaveOneOutComponent
  extends CockpitChartComponent
  implements OnInit, CockpitContentComponent
{
  card: CockpitCard;
  series: string;
  stacked = false;

  constructor(
    @Inject(ChartTemplateService)
    private readonly chartTemplateService: ChartTemplateService,
    private readonly storage: DataStorageService,
    protected readonly translate: TranslateService,
  ) {
    super();
  }

  @HostListener('window:resize')
  async ngOnInit() {
    this.storage.getAdvancedChartsData().then(data => {
      this.series = data.histogram.series;

      this.intitializeChart(this.series);

      this.translate.onLangChange.subscribe(() => {
        const svgContainer = document.getElementById(
          'svgContainerChartLeaveOneOut'
        );
        if (svgContainer) {
          this.intitializeChart(this.series);
        }
      });
    });
  }

  private intitializeChart(series: any) {
    const tmpService = this.chartTemplateService;
    tmpService.chartname = 'leaveOneOut';
    tmpService.chart.type = 'column';

    this.setChartJson(series);
    tmpService.json.credits = tmpService.getCredit();
    tmpService.json.tooltip = this.getTooltip();
    tmpService.json.exporting = tmpService.getExportMenus();
    tmpService.json.lang = tmpService.getHighchartsTranslate();
    tmpService.translateChartLabels();

    Highcharts.chart(
      'svgContainerChartLeaveOneOut',
      tmpService.json,
      thechart => {
        this.callBackFuncToNormalizeBarChart(thechart);

        const resizeObserver = new ResizeObserver(() => {
          if (this.chart) {
            this.chart.reflow();
          }
        });
        resizeObserver.observe(
          document.getElementById('svgContainerChartLeaveOneOut')
        );
      }
    );
  }

  private setChartJson(series: any) {
    const data = JSON.parse(series);
    this.chartTemplateService.json = {
      chart: {
        type: 'column',
        width: null,
      },
      title: {
        text: 'm2.ergebnis.robustheitsmass.title',
        align: 'center'
      },
      subtitle: {
        text: 'm2.ergebnis.robustheitsmass.subtitle',
        align: 'center'
      },
      xAxis: {
        min: 0,
        max: this.getMaxXAxis(data.RobustScores, data.TotalScore.value),
        type: 'category',
        title: {
          text: 'm2.ergebnis.robustheitsmass.xAxis.title'
        },
        plotLines: [
          {
            color: data.TotalScore.color,
            width: 2,
            value: data.TotalScore.value,
            dashStyle: 'longdash',
            zIndex: 4,
            label: {
              text: 'm2.ergebnis.robustheitsmass.scoreglobal'
            }
          }
        ]
      },
      yAxis: {
        title: {
          text: 'm2.ergebnis.robustheitsmass.frequency'
        }
      },
      series: [
        {
          name: 'm2.ergebnis.robustheitsmass.frequency',
          data: data.RobustScores,
          keys: ['x', 'y', 'color'],
          showInLegend: false
        }
      ]
    };
  }

  private callBackFuncToNormalizeBarChart(chart: Highcharts.Chart) {
    this.chart = chart;
    chart.reflow();
  }

  private getMaxXAxis(
    robustScores: {x: number; y: number; color: string}[],
    totalScore: number
  ) {
    const xAxisValues = robustScores.map(item => item.x);
    const maxXAxisValue = Math.max(...xAxisValues) + 1;
    if (maxXAxisValue < totalScore) {
      return totalScore;
    }
    return maxXAxisValue;
  }

  private getTooltip() {
    return {
      formatter: function () {
        const toolTip = `<span>m2.ergebnis.robustheitsmass.tooltip.xAxis.text</span>: <strong>${this.x}</strong><br/><span>m2.ergebnis.robustheitsmass.frequency</span>: <strong>${this.y}</strong><br/>`;
        return toolTip;
      }
    };
  }
}
